import {ManagementAssignmentsSelection, UserManagementConstants} from "constants"
import {DateFormat} from "../../date_format";
import UserNameFormat from "../../util/UserNameFormat";
import messageResource from "../../messageResource";
import {WarningsMap} from "./constants";
import GroupType from '../../enums/GroupType'
import {arrayToSet} from '../../atUtils'
import {userNameLower} from '../../util/pluralizeUtils'

export function canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled}) {
    const {
        hasManageUsersRight,
        hasManageScopeRight,
        hasGenerateMoneyReportsRight,
        hasManageOtherTTRight,
    } = userInfo

    return hasManageUsersRight
           || hasManageScopeRight
           || hasManageOtherTTRight
           || (hasGenerateMoneyReportsRight && (isURAEnabled || isBTYEnabled))
}

export function canManageUsersRight(userInfo) {
    return userInfo.hasManageUsersRight
}

export function isPossibleToEditUserAssignments({userInfo, isURAEnabled, isBTYEnabled}) {
    return canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled}) && !canManageUsersRight(userInfo)
}

export function canAccessAllWorkScope({userInfo, isURAEnabled, isBTYEnabled}) {
    return userInfo.hasManageUsersRight
           || (canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled}) && userInfo.managementAssignmentsSelection === ManagementAssignmentsSelection.ALL)
}

export function doesUserCanEnterTimeTrack(userInfo) {
    return userInfo.hasSubmitTTRight
}

export function isWorkScopeChangeable({userInfo, isURAEnabled, isBTYEnabled}) {
    const {
        hasManageUsersRight,
        canManageAllScope
    } = userInfo

    return !hasManageUsersRight && !(canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled}) && canManageAllScope)
}

export const createWarningMsgs = (userInfo, isCreatingUser) => {
    const warnings = userInfo.warnings;
    if (!warnings)
        return {};

    const warningMsgs = [];
    const infoMsgs = [];

    const fullName = UserNameFormat.formatFML(
        userInfo.firstName,
        userInfo.lastName,
        userInfo.middleInitial
    );

    for (let i = 0; i < warnings.length; i++) {
        const warningCode = warnings[i];

        if (warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ||
            warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ||
            warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_LICENSE_TERMS) {

            const key = warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ?
                        "userlist.js.warning_account_disabled_due_to_license_terms_at" :
                        warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ?
                        "userlist.js.warning_account_disabled_due_to_license_terms_ap" :
                        "userlist.js.warning_account_disabled_due_to_license_terms_both_products";

            const messagePart1 = messageResource.getEscapedMessage(key, [fullName]);
            const messagePart2 = messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_license_terms_info", [fullName]);

            warningMsgs.push(messagePart1 + "<p class='sameMsgNewParagraph'>" + messagePart2 + "</p>");
        }
        else if (warningCode === UserManagementConstants.WARNING_USER_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_user_group_no_longer_exists", [fullName]));

        }
        else if (warningCode === UserManagementConstants.WARNING_TIME_ZONE_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_time_zone_group_no_longer_exists", [fullName]));
        }
        else if (warningCode === UserManagementConstants.WARNING_NO_RIGHT_TO_EDIT_STATUS_IN_OTHER_PRODUCT) {
            warningMsgs.push(messageResource.getEscapedMessage(
                isCreatingUser ?
                "userlist.js.warning_no_right_to_edit_status_in_ap.creating" :
                "userlist.js.warning_no_right_to_edit_status_in_ap.editing"));
        }
        else if (warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_FUTURE_HIRE_DATE) {
            let formattedHireDate = new DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_at", [formattedHireDate]));
        }
        else if (warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_FUTURE_HIRE_DATE) {
            let formattedHireDate = new DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_ap", [formattedHireDate]));
        }
        else if (warningCode === UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_FUTURE_HIRE_DATE) {
            let formattedHireDate = new DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_both_products", [formattedHireDate]));
        }
        else if (WarningsMap.hasOwnProperty([warningCode]))
            warningMsgs.push(messageResource.getEscapedMessage(WarningsMap[warningCode]));
        else
            throw "Unknown warning code has been received from the server: " + warningCode;
    }

    return {warningMsgs: warningMsgs, infoMsgs: infoMsgs};
}

export const getUserSelectionDescription = (selection, allUsers) => {
    const groups = selection.getFirstLevel()
    const users = selection.getSecondLevel()
    const type = selection.groupType

    const noneSelected = !type && users.length === 0 || groups.length === 0 && users.length === 0
    if (noneSelected) {
        return messageResource.getEscapedMessage("users_selector.short_no_users_selected")
    } else {
        const groupIds = arrayToSet(groups.map(g => g.id))
        const userIds = arrayToSet(users.map(u => u.id))
        let selectedUsers = users
        if (type === GroupType.USER_GROUP) {
            selectedUsers = allUsers.filter((user) => (groupIds[user.userGroupId] || userIds[user.id]))
        } else if (type === GroupType.TIME_ZONE_GROUP) {
            selectedUsers = allUsers.filter((user) => (groupIds[user.timeZoneGroupId] || userIds[user.id]))
        }
        const itemNoun = userNameLower(selectedUsers.length)
        return selectedUsers.length + " " + itemNoun
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/utils.js